import { actions } from "@shared/template/StoreTemplates/FilterStoreTemplate"
import * as chainService from "@hub/management/src/modules/chains/services/chain.service"
import * as posService from "@hub/management/src/modules/pos/services/pos.service"
import * as roleService from "@hub/management/src/modules/roles/services/roles.service"

export default {
  async fetchRolesOptions({commit}) { 
    try {
      const data = await roleService.getAllRoles()
      commit("updateRolesOptions", data)
    } catch (error) {
      console.error(error)
    }
  },
  async fetchChainsOptions({commit}) { 
    try {
      const data = await chainService.getAllChain()
      commit("updateChainsOptions", data)
    } catch (error) {
      console.error(error)
    }
  },
  async fetchPosOptions({commit}) {
    try {
      const data = await posService.getAllPos()
      commit("updatePosOptions", data)
    } catch (error) {
      console.error(error)
    }
  },
  ...actions
}
